import React, { useEffect, useContext } from "react";
import MyHeader from "../../components/Customer/general/MyHeader";
import BottomNav from "../../components/Customer/general/BottomNav";
import AppContext from "../../context/AppContext";

const CustomerMasterLayout = ({ children, screenName, centered = true }) => {
  const { setAuthToken } = useContext(AppContext);

  useEffect(() => {
    const authToken = localStorage.getItem('authToken');
    setAuthToken(authToken);
  }, []);

  return (
    <>
      <MyHeader screenName={screenName} centered={centered} />
      {children}
      <BottomNav />
    </>
  );
};

export default CustomerMasterLayout;